import { render, staticRenderFns } from "./HistoryPackageHistory.vue?vue&type=template&id=7f77946f&scoped=true"
import script from "./HistoryPackageHistory.vue?vue&type=script&lang=js"
export * from "./HistoryPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f77946f",
  null
  
)

export default component.exports